<template>
  <div class="container" style="width: 100%;padding: 16px;">
    <span style="color:red">手机端粘贴按钮可能不行!!建议不依靠按钮</span>
    <Form>
      <FormItem label="加密前">
        <Button style="float:right" size="small" type="info" @click="clip">粘贴</Button>
        <Input v-model="srcVal" :rows="8" type="textarea" ref="src1" />
      </FormItem>
      <FormItem label="睡眠数值(单位ms)">
        <Input type="number" v-model="sleepval"></Input>
      </FormItem>
      <FormItem label="加密后">
        <Button class="declare_copybtn" style="float:right" size="small" type="info" v-if="isSupported">复制</Button>
        <Input v-model="destVal" :rows="8" type="textarea" />
      </FormItem>

      <FormItem>
        <div style="display:flex;justify-content: space-between;margin:8px 0px">
          <Button type="primary" style="flex: 1;" @click="starauth">加密声明文件</Button>
          <div style="width:8px"></div>
          <Button type="warning" style="flex: 1;" @click="download">下载文件</Button>
        </div>
      </FormItem>
    </Form>
  </div>
</template>
<script>
function copytext(text) {
  if (navigator.clipboard) {
    // clipboard api 复制
    navigator.clipboard.writeText(text)
  } else {
    var textarea = document.createElement("textarea")
    document.body.appendChild(textarea)
    // 隐藏此输入框
    textarea.style.position = "fixed"
    textarea.style.clip = "rect(0 0 0 0)"
    textarea.style.top = "10px"
    // 赋值
    textarea.value = text
    // 选中
    textarea.select()
    // 复制
    document.execCommand("copy", true)
    // 移除输入框
    document.body.removeChild(textarea)
  }
}

function base64(rawStr) {
  var wordArray = CryptoJS.enc.Utf8.parse(rawStr)
  var base64str = CryptoJS.enc.Base64.stringify(wordArray)
  return base64str
}

function frombase64(rawStr) {
  var parsedWordArray = CryptoJS.enc.Base64.parse(rawStr)
  var parsedStr = parsedWordArray.toString(CryptoJS.enc.Utf8)
  return parsedStr
}

export default {
  data() {
    let isSupported = window.Clipboard.isSupported()
    return {
      srcVal: "应用名:${appname},剩余天数:${authleftdays},到期时间:${expired}",
      isSupported,
      destVal: "",
      sleepval: 100,
    }
  },
  methods: {
    add(month) {
      this.expiredt = moment(this.expiredt).add(month, "months").toDate()
    },

    clip() {
      navigator.clipboard.readText().then((c) => {
        this.srcVal = c.toString()
        this.$toast.success("粘贴完成")
      })
    },
    copy(text) {
      copytext(text)
      this.$toast.success("复制完成")
    },
    starauth() {
      let declareinfo = {
        declaretmpl: this.srcVal,
        sleepms: this.sleepval,
      }

      this.$app.http
        .post("core.auth.genAuth", {
          authinfo: declareinfo,
        })
        .then((res) => {
          this.destVal = res.toString()
        })
    },
    download() {
      if (this.destVal) {
        this.$app.helper.file.fileSaver(new Blob([this.destVal], { type: "text/plain;charset=utf-8" }), "declaretmpl.txt")

        // let arr = this.srcVal.match(/(?<=\$\{)(.+?)(?=\})/g)
        let arr = this.srcVal.match(new RegExp(`(?<=\\$\\{)(.+?)(?=\\})`,"g"))

        let obj = {}
        for (const key of arr) {
          obj[key] = ""
        }

        obj = lodash.omit(obj, ["appname", "authleftdays", "expired"])
        let str = JSON.stringify(obj, null, 2)
        this.$app.helper.file.fileSaver(new Blob([str], { type: "text/plain;charset=utf-8" }), "declareobj.txt")
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.clipboard = new window.Clipboard(".declare_copybtn", {
        target: function (trigger) {
          return trigger.nextElementSibling
        },
      })
    })
  },
  destroyed() {
    if (this.clipboard) this.clipboard.destroy()
  },
}
</script>
<style lang="scss" scoped>
.container {
  margin: 0 auto;
  .ivu-form-item {
    margin: 0 !important;
  }
}
</style>